import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-section">
            <h4>The Hosting Hive</h4>
            <p>Custom development, managed hosting, and website care for businesses that need reliable technology and responsive support.</p>
            <div className="footer-contact">
              <p><strong>Email:</strong> <a href="mailto:hello@thehostinghive.net">hello@thehostinghive.net</a></p>
              <p><strong>Projects:</strong> <a href="mailto:requests@thehostinghive.net">requests@thehostinghive.net</a></p>
              <p><strong>Hours:</strong> Monday–Friday, 9 AM–6 PM PST</p>
            </div>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Custom Development</Link></li>
              <li><Link to="/services">Managed Hosting</Link></li>
              <li><Link to="/services">Website Care</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/pricing#faq">FAQ</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Get Started</h4>
            <p>Book a free 30-minute consultation to review your site, goals, and the right plan for your business.</p>
            <Link to="/contact" className="cta-button footer-cta-button">Request Consultation</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} The Hosting Hive. All rights reserved.</p>
            <div className="footer-legal">
              <Link to="/contact">Privacy Inquiries</Link>
              <Link to="/contact">Terms Inquiries</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
